var map = {
	"./debug/code.svg": 4162,
	"./debug/debug.svg": 5574,
	"./debug/next-frame.svg": 9149,
	"./debug/playback-rate.svg": 8106,
	"./debug/prev-frame.svg": 3276,
	"./fullscreen/enter.svg": 4954,
	"./fullscreen/exit.svg": 4358,
	"./loaders/loader.svg": 731,
	"./playback/pause.svg": 2930,
	"./playback/play.svg": 7890,
	"./playback/replay.svg": 4699,
	"./social/facebook.svg": 4321,
	"./social/share.svg": 545,
	"./social/twitter.svg": 7353,
	"./subtitles/selected.svg": 404,
	"./subtitles/toggle.svg": 6343,
	"./volume/loud.svg": 6016,
	"./volume/muted.svg": 857,
	"./volume/quiet.svg": 5364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3121;